import SchoolCreate from './SchoolCreate';

export default {
  name: 'schools',
  create: SchoolCreate,
};
